import React from "react";
import "./bonus-menu.scss";
import { useTranslation } from "react-i18next";
import CusButton from "../../../mui/custom_button/CusButton";
import imgPresent from "./present.webp";
import useDynamicImages from "../../../../hooks/useDynamicImages.js";
import { setOpenMenu } from "../../../../store/siteSlice.js";
import { useDispatch } from "react-redux";
import { ENUM_COMMON_EVENT } from "../../../../hooks/common/useListener.js";
import { dispatchCusEvent } from "../../../../utils/utils.js";
import useGetLink from "../../../../hooks/other/useGetLink.js";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../store/index.ts";

export default function BonusBannerMenu() {
  const { t } = useTranslation();
  const linkPromo = useGetLink("/promotions");
  const dispatch = useDispatch();
  const { imgBonusMenu } = useDynamicImages();

  const isMenuAbsolute = useAppSelector((state) => state.deviceSize.isMenuAbsolute);

  const onGo = () => {
    dispatch(setOpenMenu(false));
    dispatchCusEvent(ENUM_COMMON_EVENT.getBonus);
  };

  return imgBonusMenu ? (
    <Link to={linkPromo} onClick={onGo}>
      <div className="bonus-menu__img__container">
        <img
          className="bonus-menu__img"
          alt={t("bonus img")}
          src={imgBonusMenu}
          width={isMenuAbsolute ? 182 : 272}
        />
      </div>
    </Link>
  ) : (
    <div className="bonus-menu">
      <h2>{t("Play casino games and get bonuses!")}</h2>
      <CusButton className="go-btn" to={linkPromo} color="custom" text={"Bonuses"} onClick={onGo} />
      <img src={imgPresent} alt={t("img present")} />
      <div className="bonus-menu__gradient" />
    </div>
  );
}
